module.exports = __webpack_public_path__ + "img/index-view.229d5185.png";